import _ from 'lodash';
import { createSelector } from 'reselect';

export const getUserMap = state => state.users;

const getUserSlug = (state, slug) => slug;

export const getUserById = (state, userId) => state.users[userId];

const getIdList = (state, idList) => idList;

export const getUsersByIdList = createSelector([getUserMap, getIdList], (users, idList) =>
  _.map(idList, id => users[id])
);

export const getUserBySlug = createSelector([getUserMap, getUserSlug], (users, slug) => _.find(users, ['slug', slug]));



// WEBPACK FOOTER //
// ./app/selectors/user-selectors.js